/*
 * Copyright (C) Fraunhofer IESE 2021-2025 - Mher Ter-Tovmasyan
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import {
  GeoAreasApi,
  GetGeoAreaRequest,
  SearchGeoAreasRequest
} from '@slr/geo-service-sdk';
import { handleError } from '@slr/shared-library';
import { useCallback, useMemo } from 'react';
import { useGetGeoAreaServiceApiConfiguration } from './geoArea.service';

export const useGeoAreasApi = () => {
  const configuration = useGetGeoAreaServiceApiConfiguration();
  const apiInstance = useMemo(
    () => new GeoAreasApi(configuration),
    [configuration]
  );

  const getGeoArea = useCallback(
    (requestParameters: GetGeoAreaRequest) =>
      apiInstance.getGeoArea(requestParameters).catch(handleError),
    [apiInstance]
  );

  const searchGeoAreas = useCallback(
    (requestParameters: SearchGeoAreasRequest) =>
      apiInstance.searchGeoAreas(requestParameters).catch(handleError),
    [apiInstance]
  );
  return { getGeoArea, searchGeoAreas };
};
